/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.customassistants.rpc.CustomAssistantsService
 */
import * as References from './CustomAssistantsService';
import { createRpcClientV2, type RpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import {
  DataFetchingClientFetcherContext,
  RegisteredQuery,
} from 'data-fetching-client';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
export type AdditionalContextArgs = {
  /**
   * Timeout for the request in milliseconds. If not provided, the timeout configured for this RPC is used, falling back to 5000.
   */
  timeout?: number;
  /**
   * Not recommended for usage. Please use build time client instead by updating `.client-types.config.ts`file.
   * Docs: https://product.hubteam.com/docs/chirp/pages/tutorials/chirp/FE/custom-clients.html.
   *
   * Used to overwrite the default Chirp Client during runtime.
   */
  customClient?: RpcClientV2;
};

export const chirpClient = createRpcClientV2({
  hubHttpClient: http,
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.customassistants.rpc.CustomAssistantsService#getCustomAssistant
 */
export const GET_CUSTOM_ASSISTANT_QUERY_FIELD_NAME =
  'com_hubspot_customassistants_rpc_CustomAssistantsService_getCustomAssistant';
export const GET_CUSTOM_ASSISTANT_QUERY: RegisteredQuery<
  'result',
  References.GetCustomAssistantRequestType,
  References.GetCustomAssistantResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_CUSTOM_ASSISTANT_QUERY_FIELD_NAME,
  args: ['id'],
  fetcher(
    request: References.GetCustomAssistantRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetCustomAssistantResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getCustomAssistantRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.customassistants.rpc.CustomAssistantsService#getConversationStarters
 */
export const GET_CONVERSATION_STARTERS_QUERY_FIELD_NAME =
  'com_hubspot_customassistants_rpc_CustomAssistantsService_getConversationStarters';
export const GET_CONVERSATION_STARTERS_QUERY: RegisteredQuery<
  'result',
  References.GetConversationStartersRequestType,
  References.GetConversationStartersResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_CONVERSATION_STARTERS_QUERY_FIELD_NAME,
  args: ['customAssistantId', 'threadId', 'pageContext', 'crmObjectContext'],
  fetcher(
    request: References.GetConversationStartersRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetConversationStartersResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getConversationStartersRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.customassistants.rpc.CustomAssistantsService#listCustomAssistants
 */
export const LIST_CUSTOM_ASSISTANTS_QUERY_FIELD_NAME =
  'com_hubspot_customassistants_rpc_CustomAssistantsService_listCustomAssistants';
export const LIST_CUSTOM_ASSISTANTS_QUERY: RegisteredQuery<
  'result',
  References.ListCustomAssistantsRequestType,
  References.ListCustomAssistantsResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: LIST_CUSTOM_ASSISTANTS_QUERY_FIELD_NAME,
  args: [
    'pageLength',
    'searchTerm',
    'filterByPermissions',
    'authorName',
    'filterByAuthor',
    'updatedBy',
    'sortField',
    'sortDirection',
    'offset',
  ],
  fetcher(
    request: References.ListCustomAssistantsRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.ListCustomAssistantsResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.listCustomAssistantsRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.customassistants.rpc.CustomAssistantsService#createCustomAssistant
 */
export const CREATE_CUSTOM_ASSISTANT_MUTATION_FIELD_NAME =
  'com_hubspot_customassistants_rpc_CustomAssistantsService_createCustomAssistant';
export const CREATE_CUSTOM_ASSISTANT_MUTATION: RegisteredQuery<
  'result',
  References.CreateCustomAssistantRequestType,
  References.CreateCustomAssistantResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: CREATE_CUSTOM_ASSISTANT_MUTATION_FIELD_NAME,
  args: [
    'name',
    'welcomeMessage',
    'instructions',
    'setUpInstructions',
    'icon',
    'description',
    'status',
    'enabledContext',
    'conversationStarters',
    'conversationStartersConfig',
    'model',
    'resources',
    'enabledBuiltInTools',
    'permissions',
    'feedbackCorrelationId',
  ],
  fetcher(
    request: References.CreateCustomAssistantRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.CreateCustomAssistantResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.createCustomAssistantRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.customassistants.rpc.CustomAssistantsService#duplicateCustomAssistant
 */
export const DUPLICATE_CUSTOM_ASSISTANT_MUTATION_FIELD_NAME =
  'com_hubspot_customassistants_rpc_CustomAssistantsService_duplicateCustomAssistant';
export const DUPLICATE_CUSTOM_ASSISTANT_MUTATION: RegisteredQuery<
  'result',
  References.DuplicateCustomAssistantRequestType,
  References.DuplicateCustomAssistantResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: DUPLICATE_CUSTOM_ASSISTANT_MUTATION_FIELD_NAME,
  args: ['id'],
  fetcher(
    request: References.DuplicateCustomAssistantRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.DuplicateCustomAssistantResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.duplicateCustomAssistantRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.customassistants.rpc.CustomAssistantsService#updateCustomAssistant
 */
export const UPDATE_CUSTOM_ASSISTANT_MUTATION_FIELD_NAME =
  'com_hubspot_customassistants_rpc_CustomAssistantsService_updateCustomAssistant';
export const UPDATE_CUSTOM_ASSISTANT_MUTATION: RegisteredQuery<
  'result',
  References.UpdateCustomAssistantRequestType,
  References.UpdateCustomAssistantResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: UPDATE_CUSTOM_ASSISTANT_MUTATION_FIELD_NAME,
  args: [
    'id',
    'name',
    'welcomeMessage',
    'instructions',
    'setUpInstructions',
    'icon',
    'description',
    'status',
    'enabledContext',
    'conversationStarters',
    'conversationStartersConfig',
    'model',
    'resources',
    'enabledBuiltInTools',
    'permissions',
    'feedbackCorrelationId',
  ],
  fetcher(
    request: References.UpdateCustomAssistantRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.UpdateCustomAssistantResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.updateCustomAssistantRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.customassistants.rpc.CustomAssistantsService#deleteCustomAssistant
 */
export const DELETE_CUSTOM_ASSISTANT_MUTATION_FIELD_NAME =
  'com_hubspot_customassistants_rpc_CustomAssistantsService_deleteCustomAssistant';
export const DELETE_CUSTOM_ASSISTANT_MUTATION: RegisteredQuery<
  'result',
  References.DeleteCustomAssistantRequestType,
  References.DeleteCustomAssistantResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: DELETE_CUSTOM_ASSISTANT_MUTATION_FIELD_NAME,
  args: ['id', 'feedbackCorrelationId'],
  fetcher(
    request: References.DeleteCustomAssistantRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.DeleteCustomAssistantResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.deleteCustomAssistantRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.customassistants.rpc.CustomAssistantsService#installCustomAssistantTemplateFromGlobalId
 */
export const INSTALL_CUSTOM_ASSISTANT_TEMPLATE_FROM_GLOBAL_ID_MUTATION_FIELD_NAME =
  'com_hubspot_customassistants_rpc_CustomAssistantsService_installCustomAssistantTemplateFromGlobalId';
export const INSTALL_CUSTOM_ASSISTANT_TEMPLATE_FROM_GLOBAL_ID_MUTATION: RegisteredQuery<
  'result',
  References.InstallCustomAssistantTemplateFromGlobalIdRequestType,
  References.InstallCustomAssistantTemplateFromGlobalIdResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName:
    INSTALL_CUSTOM_ASSISTANT_TEMPLATE_FROM_GLOBAL_ID_MUTATION_FIELD_NAME,
  args: ['templateGlobalId'],
  fetcher(
    request: References.InstallCustomAssistantTemplateFromGlobalIdRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.InstallCustomAssistantTemplateFromGlobalIdResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.installCustomAssistantTemplateFromGlobalIdRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.customassistants.rpc.CustomAssistantsService#lookupUserInstalledAssistantByGlobalId
 */
export const LOOKUP_USER_INSTALLED_ASSISTANT_BY_GLOBAL_ID_QUERY_FIELD_NAME =
  'com_hubspot_customassistants_rpc_CustomAssistantsService_lookupUserInstalledAssistantByGlobalId';
export const LOOKUP_USER_INSTALLED_ASSISTANT_BY_GLOBAL_ID_QUERY: RegisteredQuery<
  'result',
  References.LookupUserInstalledAssistantByGlobalIdRequestType,
  References.LookupUserInstalledAssistantByGlobalIdResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: LOOKUP_USER_INSTALLED_ASSISTANT_BY_GLOBAL_ID_QUERY_FIELD_NAME,
  args: ['globalId'],
  fetcher(
    request: References.LookupUserInstalledAssistantByGlobalIdRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.LookupUserInstalledAssistantByGlobalIdResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.lookupUserInstalledAssistantByGlobalIdRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.customassistants.rpc.CustomAssistantsService#findAssistantsByResourceId
 */
export const FIND_ASSISTANTS_BY_RESOURCE_ID_QUERY_FIELD_NAME =
  'com_hubspot_customassistants_rpc_CustomAssistantsService_findAssistantsByResourceId';
export const FIND_ASSISTANTS_BY_RESOURCE_ID_QUERY: RegisteredQuery<
  'result',
  References.FindAssistantsByResourceIdRequestType,
  References.FindAssistantsByResourceIdResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: FIND_ASSISTANTS_BY_RESOURCE_ID_QUERY_FIELD_NAME,
  args: ['resourceType', 'resourceId', 'pageLength', 'offset'],
  fetcher(
    request: References.FindAssistantsByResourceIdRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.FindAssistantsByResourceIdResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.findAssistantsByResourceIdRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.customassistants.rpc.CustomAssistantsService#submitPromptFeedback
 */
export const SUBMIT_PROMPT_FEEDBACK_MUTATION_FIELD_NAME =
  'com_hubspot_customassistants_rpc_CustomAssistantsService_submitPromptFeedback';
export const SUBMIT_PROMPT_FEEDBACK_MUTATION: RegisteredQuery<
  'result',
  References.SubmitPromptFeedbackRequestType,
  References.SubmitPromptFeedbackResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: SUBMIT_PROMPT_FEEDBACK_MUTATION_FIELD_NAME,
  args: [
    'customAssistantId',
    'customAssistantTemplateGlobalId',
    'generatedPrompt',
    'positive',
    'explicit',
    'feedback',
    'correlationId',
  ],
  fetcher(
    request: References.SubmitPromptFeedbackRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.SubmitPromptFeedbackResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.submitPromptFeedbackRpc,
      { timeout: ctx.timeout, request }
    );
  },
});
